import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import {
  Body,
  ButtonAction,
  ButtonsContainer,
  DataBox,
  dialogPanel,
  dialogTitle
} from './styles'
import { IoCloseSharp } from 'react-icons/io5'
import { AiOutlineExclamationCircle } from 'react-icons/ai'

interface ProtocolInfoOkProps {
  handleCloseModal: () => void
  isOpen: boolean
  notificationById: any
  protocolInfoOkData: {
    title: string;
    subtitle: string;
  }
  boxText: {
    upperText: string
    downText:string
  }
}

const ProtocolInfoOk: React.FC<ProtocolInfoOkProps> = ({
  handleCloseModal,
  isOpen,
  notificationById,
  boxText,
  protocolInfoOkData
}) => {

  return (
    <>
      <Transition
        appear
        show={isOpen}
        as={Fragment}
      >
        <Dialog
          as="div"
          className="relative z-10"
          onClose={handleCloseModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`${dialogPanel}`}>
                  <Dialog.Title
                    as="h3"
                    className={dialogTitle}
                  >
                    <p className="text-blueTheme text-xl font-semibold">
                      {protocolInfoOkData.title}
                    </p>
                    <IoCloseSharp
                      onClick={handleCloseModal}
                      className="text-blueTheme h-8 w-8 p-1 cursor-pointer"
                    />
                  </Dialog.Title>
                  <Body >
                    <p className="text-sm">
                      {protocolInfoOkData.subtitle}
                    </p>
                    <DataBox>
                      <div className="flex flex-col gap-1 justify-center items-center mb-2">
                        <div className='flex items-center gap-1 '>
                          <AiOutlineExclamationCircle
                            className={'text-yellow font-bold'}
                            size={20}
                          />
                          <span className='text-yellow font-semibold text-sm'>{boxText.upperText}</span>
                        </div>
                        <span className='text-darkGray text-sm'>{boxText.downText}</span>
                      </div>

                    </DataBox>
                    <ButtonsContainer>
                      <ButtonAction
                        onClick={() => {
                          handleCloseModal()
                        }}
                        type="button"
                        className="text-blueTheme text-sm"
                      >
                        OK
                      </ButtonAction>
                    </ButtonsContainer>

                  </Body>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export { ProtocolInfoOk }
